










import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import ColorPicker from '@/components/common/colorpicker/ColorPicker.vue';

@Component({
  components: {
    ColorPicker
  }
})
export default class ColorPickerButton extends Vue {
  @Prop({default: '#ffffff'}) public defaultColorHexCode: string;

  private globalDimmedElement: HTMLElement = document.getElementById('pop');
  private isEnableColorPicker: boolean = false;
  private temporarySelectColorHexCode: string = this.defaultColorHexCode;
  private selectColorHexCode: string = this.defaultColorHexCode;

  @Watch('defaultColorHexCode')
  private onDefaultColorHexCodeChanged() {
    this.onUpdateColor(this.defaultColorHexCode);
    this.onSelectColor();
  }

  mounted() {
    this.initDimmedArea();
  }

  destroyed() {
    this.disableColorPicker();
  }

  private initDimmedArea(): void {
    this.globalDimmedElement.addEventListener('click', () => {
      this.disableColorPicker();
    });
  }

  private onClickColorPicker() {
    this.enableColorPicker();
  }

  private onSelectColor() {
    this.selectColorHexCode = this.temporarySelectColorHexCode;
  }

  public enableColorPicker(): void {
    this.globalDimmedElement.style.display = 'block';
    this.isEnableColorPicker = true;
  }

  public disableColorPicker(): void {
    this.globalDimmedElement.style.display = 'none';
    this.isEnableColorPicker = false;
  }

  private onClickSubmit() {
    this.onSelectColor();
    this.disableColorPicker();

    this.$emit('onSelect', this.selectColorHexCode);
  }

  public onUpdateColor(color: string) {
    this.temporarySelectColorHexCode = color;
  }
}
